import React from "react";

export const olfactoryNoteKey = (note = "") => note.trim().toLocaleLowerCase("it-IT");

const splitNotes = (value = "") => value
  .replace(/\s+/g, " ")
  .split(/\s*[,;·]\s*|\s+E\s+/i)
  .map((note) => note.trim().replace(/[.:]+$/, ""))
  .filter(Boolean);

const levels = [
  { key: "top", it: "Note di apertura", en: "Top notes" },
  { key: "heart", it: "Note centrali", en: "Heart notes" },
  { key: "base", it: "Note di base", en: "Base notes" },
];

export const splitOlfactoryNotes = splitNotes;

export const OlfactoryPyramid = ({ pyramid, noteImages = {}, lang = "it" }) => (
  <section className="overflow-hidden border border-stone-200 bg-white" data-testid="olfactory-pyramid">
    <div className="border-b border-stone-200 px-5 py-5 md:px-7">
      <p className="font-serif text-xl text-charcoal">
        {lang === "it" ? "Piramide del profumo" : "Fragrance pyramid"}
      </p>
      <p className="mt-1 text-[10px] uppercase tracking-[0.18em] text-stone-400">
        {lang === "it" ? "Scopri l’evoluzione della fragranza" : "Discover how the fragrance evolves"}
      </p>
    </div>

    <div className="divide-y divide-stone-200">
      {levels.map(({ key, it, en }) => {
        const notes = splitNotes(pyramid?.[key]);
        if (!notes.length) return null;
        return (
          <div key={key} className="px-4 py-7 md:px-7 md:py-8">
            <div className="mb-5 flex items-center gap-3">
              <span className="h-px flex-1 bg-stone-200" />
              <h3 className="text-[11px] uppercase tracking-[0.2em] text-stone-500">{lang === "it" ? it : en}</h3>
              <span className="h-px flex-1 bg-stone-200" />
            </div>
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-4">
              {notes.map((note, index) => (
                <div key={`${key}-${note}-${index}`} className={`group text-center ${noteImages[olfactoryNoteKey(note)] ? "" : "flex min-h-20 items-center justify-center border border-stone-200 bg-[#faf9f7] px-3"}`}>
                  {noteImages[olfactoryNoteKey(note)] && (
                    <div className="mx-auto aspect-square w-full max-w-[112px] overflow-hidden rounded-lg border border-stone-200 bg-stone-50 transition-transform duration-300 group-hover:-translate-y-1">
                      <img src={noteImages[olfactoryNoteKey(note)]} alt={note} className="h-full w-full object-cover" />
                    </div>
                  )}
                  <p className={`${noteImages[olfactoryNoteKey(note)] ? "mt-2" : ""} text-xs leading-4 text-charcoal normal-case`}>
                    {note.toLocaleLowerCase(lang === "it" ? "it-IT" : "en-US").replace(/^./, (c) => c.toUpperCase())}
                  </p>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  </section>
);
